import NamedDto from 'modules/base/dto/NamedDto';

export class Lummus2ModelInputUnitOpEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.code = null;
		/** @type {string} */
		this.typeCode = null;
	}

	/**
	 * @typedef {Object} _Lummus2ModelInputUnitOpEditDtoProps
	 * @property {string} code
	 * @property {string} typeCode
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _Lummus2ModelInputUnitOpEditDtoProps} Lummus2ModelInputUnitOpEditDtoProps
	 */
	/**
	 *
	 * @param {Lummus2ModelInputUnitOpEditDtoProps} props
	 * @returns {Lummus2ModelInputUnitOpEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.code = props.code;
		this.typeCode = props.typeCode;
		return this;
	}
}

export default Lummus2ModelInputUnitOpEditDto;
